"use strict";

// todo сделать на бале виджета, использующего в левой панели
$.widget("fotobook.calendarBorderWidget", $.fotobook.containereditordropdownbase, {
    "options" : {
        "closeOnSelect" : false,
    },
    getCurrentBordersValue: function(){
        return parseInt(this.getContainer().attr("data-borders"), 10);
    },
    _processItemClick: function(event){
        var $itm = $(event.target),
            value = parseInt($itm.attr("data-value"), 10),
            remove = $itm.hasClass("active"),
            currentValue = this.getCurrentBordersValue();

        if (value === 0){
            // если 0 - просто сбрасываем всё
        } else if (remove){
            // сбрасываем биты
            value = currentValue & ~value;
        } else {
            // устанавливаем биты
            value = currentValue | value;
        }

        // выполняем запрос только если значение изменилось
        if (value !== currentValue){
            Fotobook.containers.calendar.changeAttribute(this.getContainer(), "borders", value);
        }
        this._super();
    },
    _menuTpl: [
        '<div class="tb-dropdown-options redactor-dropdown skip-positioning">',
            '<div class="tb-button tb-element calendarBorder-none edit-icons-sprite dropdown-item" data-value="', Fotobook.containers.calendar.BORDER_NONE, '"></div>',
            '<div class="tb-button tb-element calendarBorder-vertical edit-icons-sprite dropdown-item" data-value="', Fotobook.containers.calendar.BORDER_VERTICAL, '"></div>',
            '<div class="tb-button tb-element calendarBorder-horizontal edit-icons-sprite dropdown-item" data-value="', Fotobook.containers.calendar.BORDER_HORIZONTAL, '"></div>',
            '<div class="tb-button tb-element calendarBorder-all edit-icons-sprite dropdown-item" data-value="', Fotobook.containers.calendar.BORDER_ALL_IMPLEMENTED, '"></div>',
        '</div>',
    ].join(""),
    _createDropdown: function(){
        return $(this._menuTpl);
    },
    _containerChanged: function(){
        var borders = this.getCurrentBordersValue();

        this.dropdown.find(".dropdown-item").each(function(){
            var $this = $(this),
                value = parseInt($this.attr("data-value"), 10), 
                active = false;

            if (!borders && !value){
                active = true;
            } else if (value){
                active = (borders & value) === value;
            }
            $this.toggleClass("active", active);
        });
    },
});
